import { Reducer } from 'redux';

// Actions

export const toggleWalletMobileHeaderStats = () => ({
  type: 'TOGGLE_WALLET_MOBILE_HEADER_STATS' as const,
});

type WalletSectionAction = ReturnType<typeof toggleWalletMobileHeaderStats>;

// Reducer
type WalletSectionState = {
  mobileHeaderStatsExpanded: boolean;
};

// @cached
export const walletSectionReducer: Reducer<
  WalletSectionState,
  WalletSectionAction
> = (
  state = {
    mobileHeaderStatsExpanded: true,
  },
  action
): WalletSectionState => {
  switch (action.type) {
    case 'TOGGLE_WALLET_MOBILE_HEADER_STATS':
      return {
        mobileHeaderStatsExpanded: !state.mobileHeaderStatsExpanded,
      };
    default:
      return state;
  }
};
